<span class="warning" [ngClass]="{ 'green': color === 'green' }">{{ message }}</span>
